import { createContext } from 'react';
import { FormattedRoute } from '../@types';

const RoutesContext = createContext<FormattedRoute[]>([]);

export default RoutesContext;
